import { error, finish } from '../../../modules/system-settings/actions/put-bet-limit-settings';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

function createValue(value) {
    if (value === null || value === undefined) {
        return null;
    }
    return new Amount(value).value;
}
function createOldLongAndCheckNull(value) {
    if (value === null) {
        return null;
    }

    return $appState.configState.precision.valueOldFormat(new Amount(value));
}



export function request(dispatch, { data }) {
    const oldFromNewData = {
        ...data,
        maxPayout: createOldLongAndCheckNull(data.maxPayout),
        maxPayoutPrecise: data.maxPayout,
        maxAutoPayout: createOldLongAndCheckNull(data.maxAutoPayout),
        maxAutoPayoutPrecise: data.maxAutoPayout,
        defaultBetLimitsPrecise: {
            maxBet: data.defaultBetLimits.maxBet,
            maxWin: data.defaultBetLimits.maxWin,
            maxMultipleBet: data.defaultBetLimits.maxMultipleBet,
            liabilityLimit: data.defaultBetLimits.liabilityLimit
        },
        defaultBetLimits: {
            maxBet: createOldLongAndCheckNull(data.defaultBetLimits.maxBet),
            maxWin: createOldLongAndCheckNull(data.defaultBetLimits.maxWin),
            maxMultipleBet: createOldLongAndCheckNull(data.defaultBetLimits.maxMultipleBet),
            liabilityLimit: createOldLongAndCheckNull(data.defaultBetLimits.liabilityLimit)
        },
        defaultRabBetLimitsPrecise: {
            maxBet: data.defaultRabBetLimits.maxBet,
            maxWin: data.defaultRabBetLimits.maxWin
        },
        defaultRabBetLimits: {
            maxBet: createOldLongAndCheckNull(data.defaultRabBetLimits.maxBet),
            maxWin: createOldLongAndCheckNull(data.defaultRabBetLimits.maxWin)
        },
        minTotalStake: createOldLongAndCheckNull(data.minTotalStake),
        minTotalStakePrecise: data.minTotalStake,
        minLineStake: createOldLongAndCheckNull(data.minLineStake),
        minLineStakePrecise: data.minLineStake,
    };



    data = {
        ...data,
        defaultSpPrice: data.defaultSpPrice ?? {
            den: null,
            num: null
        },
        maxPayout: createValue(data.maxPayout),
        maxPayoutPrecise: data.maxPayout,
        maxAutoPayout: createValue(data.maxAutoPayout),
        maxAutoPayoutPrecise: data.maxAutoPayout,
        defaultBetLimits: {
            maxBet: createValue(data.defaultBetLimits?.maxBet),
            maxWin: createValue(data.defaultBetLimits?.maxWin),
            maxMultipleBet: createValue(data.defaultBetLimits?.maxMultipleBet),
            liabilityLimit: createValue(data.defaultBetLimits?.liabilityLimit)
        },
        defaultBetLimitsPrecise: {
            maxBet: data.defaultBetLimits?.maxBet,
            maxWin: data.defaultBetLimits?.maxWin,
            maxMultipleBet: data.defaultBetLimits?.maxMultipleBet,
            liabilityLimit: data.defaultBetLimits?.liabilityLimit
        },
        defaultRabBetLimits: {
            maxBet: createValue(data.defaultRabBetLimits?.maxBet),
            maxWin: createValue(data.defaultRabBetLimits?.maxWin)
        },
        defaultRabBetLimitsPrecise: {
            maxBet: data.defaultRabBetLimits?.maxBet,
            maxWin: data.defaultRabBetLimits?.maxWin
        },
        minTotalStake: createValue(data.minTotalStake),
        minTotalStakePrecise: data.minTotalStake,
        minLineStake: createValue(data.minLineStake),
        minLineStakePrecise: data.minLineStake
    };


    api.put('/betting-configs', oldFromNewData ).then(
        response => dispatch(finish( data )),
        (errors) => dispatch(error(errors))
    );
}


